import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Widget, WidgetStatus, WidgetSunstudy, WidgetTemplate } from '../models/widget';
import { Paginator } from '../models/paginator';
import { Client } from '../models/client';
import { Project } from '../models/project';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

@Injectable()
export class WidgetService {
  availableStatuses: { key: WidgetStatus, name: string }[] = [
    { key: WidgetStatus.Draft, name: 'Utkast' },
    { key: WidgetStatus.Published, name: 'Publicerad' },
    { key: WidgetStatus.Archived, name: 'Arkiverad' }
  ];

  constructor(private http: HttpClient) {
  }

  get(): Observable<Paginator<Widget>> {
    return this.http.get<any>(`${environment.apiUrl}/widgets`)
      .pipe(
        map(json => {
          let widgets = json.data.map(row => {
            return new Widget(row);
          });
          return new Paginator<Widget>(json.meta.pagination, widgets);
        })
      );
  }

  getLatest(): Observable<Widget[]> {
    return this.http.get<any>(`${environment.apiUrl}/widgets/latest`)
      .pipe(map(json => {
        return json.data.map(r => {
          return new Widget(r);
        })
      }));
  }

  getForProject(project: Project): Observable<Widget[]> {
    return this.http.get<any>(`${project.url}/widgets`)
      .pipe(
        map(json => {
          let widgets = json.data.map(row => {
            return new Widget(row);
          });

          return widgets;
        }));
  }

  getWidget(id: number): Observable<Widget> {
    return this.http.get(`${environment.apiUrl}/widgets/${id}`)
      .pipe(
        map(json => {
          return new Widget(json);
        }));
  }

  update(widget: Widget): Observable<Widget> {
    let body = JSON.stringify(widget.toJson());

    return this.http.put(`${widget.url}`, body)
      .pipe(
        map(json => {
          return new Widget(json);
        }));
  }


  getSunstudy(widget: Widget, id: number): Observable<WidgetSunstudy> {
    return this.http.get(`${widget.url}/sunstudies/${id}`)
      .pipe(map(json => {
        return new WidgetSunstudy(json);
      }));
  }

  getTemplatesForClient(client: Client): Observable<WidgetTemplate[]> {
    return this.http.get<any>(`${client.url}/widget-templates`)
      .pipe(
        map(json => {
          return json.data.map(d => {
            return new WidgetTemplate(d);
          });
        }));
  }


  create(widget: Widget): Observable<Widget> {
    let body = JSON.stringify(widget.toJson());

    return this.http.post(`${environment.apiUrl}/widgets`, body)
      .pipe(
        map(json => {
          return new Widget(json);
        })
      );
  }

  getWidgetSlug(name: string): Observable<string> {
    return this.http.get<{ slug: string }>(`${environment.apiUrl}/widget-slug?name=${name}`)
      .pipe(
        map(json => {
          return json.slug;
        }));
  }


  deleteWidget(widget: Widget): Observable<void> {
    return this.http.delete(`${widget.url}`)
      .pipe(map(response => {
        return;
      }));
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget.service.ts